import { ADD_QUOTES_TO_COMPARE } from "../ActionTypes/ActionTypes";

const initialState = [];

export const CompareQuotesReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_QUOTES_TO_COMPARE:
      state = action?.payload;
      return state;
      break;
    default:
      return state;
  }
};

export default CompareQuotesReducer;
